import { render, staticRenderFns } from "./Safeguarding.vue?vue&type=template&id=94815e9c&scoped=true&"
import script from "./Safeguarding.vue?vue&type=script&lang=js&"
export * from "./Safeguarding.vue?vue&type=script&lang=js&"
import style0 from "./Safeguarding.vue?vue&type=style&index=0&id=94815e9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94815e9c",
  null
  
)

export default component.exports